
import React, { useEffect, useState } from 'react'
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtils/CommonAxios';
import CommonReactTable from '../CommonUtils/CommonReactTable';
import { config } from '../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { successAlert2 } from '../CommonUtils/SweetAlerts';
import { FaCheckCircle } from 'react-icons/fa';

export default function UniversitySubjectFacReport() {
    const ROLEID = sessionStorage.getItem("role_id");
    const [projectdata, serProjectdata] = useState([]);
    function GetProjectStatusData() {
        let url = `${config.url.FAC_URL}getSubjectFacultyDetails`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01" &&
                res?.data?.subj_details?.length > 0) {
                serProjectdata(res?.data?.subj_details);
            } else {
                serProjectdata([]);
            }
        });
    }
    useEffect(() => {
        GetProjectStatusData();

    }, [])

    function handleApprove(sno) {
        Swal.fire({
            text: 'Are you sure you want to approve ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Approve!',
            cancelButtonText: 'Cancel',
            backdrop: false,
            confirmButtonColor: '#2e7d32',
        }).then((result) => {
            if (result.isConfirmed) {
                const url = `${config.url.FAC_URL}updateCheckerApprovalDept?sno=${sno}`;
                const payload = {
                    isCheckerApproved: true
                }
                CommonAxiosPost(url, payload).then((res) => {
                    if (res?.data?.scode === "01") {
                        successAlert2(res?.data?.sdesc);
                        GetProjectStatusData();
                    } else {
                        Swal.fire(res?.data?.sdesc || "Approval failed", "", "error");
                    }
                });
            }
        });
    }
    const SubjectReportColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,

        },
        {
            id: "dept_name",
            header: "Name of the Department / Subject",
            accessorKey: "dept_name",
            meta: { style: { textAlign: "left" } },
            Footer: "Total",

        },
        {
            id: "designation",
            header: "Name of the Designation",
            accessorKey: "designation",
            meta: { style: { textAlign: "left" } },

        },


        {
            id: "no_of_san_posts",
            header: "No of sanctioned posts (GO Ms No 95 dt 16-09-2023)",
            accessorKey: "no_of_san_posts",
            Footer: true,
        },
        {
            id: "no_of_reg_fac_working",
            header: "No of regular faculty working",
            accessorKey: "no_of_reg_fac_working",
            Footer: true,
        },
        {
            id: "no_of_contract_fac_working",
            header: "No of contract faculty working",
            accessorKey: "no_of_contract_fac_working",
            Footer: true,
        },
        {
            id: "no_of_guest_fac_working",
            header: "No of Guest faculty working",
            accessorKey: "no_of_guest_fac_working",
            Footer: true,
        },
        {
            id: "no_of_adhoc_fac_working",
            header: "No of Adhoc faculty working",
            accessorKey: "no_of_adhoc_fac_working",
            Footer: true,
        },


        ...(ROLEID === "4"
            ? [
                {
                    id: "approve",
                    header: "Approve",
                    cell: ({ row }) => {
                        const isApproved = row.original.is_checker_approved;

                        // Approved Badge (Green)
                        const approvedStyle = {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "6px 10px",      // slightly bigger
                            fontSize: "12px",         // larger text
                            fontWeight: 600,
                            borderRadius: "30px",
                            backgroundColor: "#d4edda",
                            color: "#155724",
                            border: "1.5px solid #28a745",
                            cursor: "default",
                            userSelect: "none",
                        };

                        const approveStyle = {
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            padding: "6px 10px",     // bigger padding
                            fontSize: "14px",         // larger text
                            fontWeight: 600,
                            borderRadius: "30px",
                            border: "1px solid #3b82f6",
                            backgroundColor: "#3b82f6",
                            color: "#fff",
                            cursor: "pointer",
                        };

                  

                        return isApproved ? (
                            <span style={approvedStyle}>
                                <FaCheckCircle size={20} />
                                Approved
                            </span>
                        ) : (
                            <button
                                style={approveStyle}
                                onClick={() => handleApprove(row.original.sno)}
                                
                            >
                                {/* &emsp; <FaCheckCircle size={16} /> */}
                                Approve
                            </button>
                        );
                    },
                },
            ]
            : []),
    ];
    return (
        <>

            <div className="faculty-card">
                <div className='fac-topbar'>

                    <div className='fac-detnew'>
                        <h5 className='mb-0'>Department  Report</h5>
                    </div>

                </div>
                {projectdata?.length > 0 ? (
                    <>
                        <div className="table-responsive">
                            <CommonReactTable
                                data={projectdata}
                                columns={SubjectReportColumns}
                                filename="Department wise Report"
                                headerName="Department wise Report"
                                showFooter={true}
                                showPagination={false}
                                showExcel={true}
                                showPrint={true}
                                excelFileName="Department wise Report"


                            />
                        </div>
                    </>
                ) : (<center className="text-danger h5">**** No Data Found ****</center>
                )}
            </div>







        </>)
}
